import {
  CompanyIcon,
  IssuerAndRecipientIcon,
  IssuerIcon,
  NoneIcon,
  RecipientIcon,
  UnknownIcon,
} from "../components/atoms/icons/ClientTypeIcons";
import { UserIcon } from "../components/atoms/icons/UserIcon";
import Tooltip from "../components/molecules/Tooltip";
import type { IdentifierType } from "../graphql/queries/getExternalLookupCompany";
import type { ClientType } from "../graphql/queries/getLookupCompany";

export const getClientTypeIcon = (type?: ClientType | IdentifierType) => {
  switch (type) {
    case "ISSUER":
      return (
        <Tooltip text="Utställare">
          <IssuerIcon />
        </Tooltip>
      );
    case "RECIPIENT":
      return (
        <Tooltip text="Mottagare">
          <RecipientIcon />
        </Tooltip>
      );
    case "ISSUER_AND_RECIPIENT":
      return (
        <Tooltip text="Utställare och mottagare">
          <IssuerAndRecipientIcon />
        </Tooltip>
      );
    case "NONE":
      return (
        <Tooltip text="Saknar typ">
          <NoneIcon />
        </Tooltip>
      );
    case "UNKNOWN":
      return (
        <Tooltip text="Okänd">
          <UnknownIcon />
        </Tooltip>
      );
    case "ORGANIZATION_NUMBER":
      return (
        <Tooltip text="Bolag">
          <CompanyIcon />
        </Tooltip>
      );
    case "PERSON_IDENTIFIER":
      return (
        <Tooltip text="Privatperson">
          <UserIcon />
        </Tooltip>
      );
    default:
      return <div />;
  }
};
